import axios from "@/services/axios.config";
import { toastOnError } from "@/utils/toastOnError";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { toast } from "react-toastify";

const submitForPublish = async (methodologyAdditionalInfoId: number) =>
	axios
		.post("/methodology/additional-info/submit", {
			methodologyAdditionalInfoId: methodologyAdditionalInfoId,
		})
		.then((res) => res.data.data)
		.catch((err) => Promise.reject(err.response.data as APIResponse));

export default function useSubmitForPublish() {
	const router = useRouter();
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: ["submitForPublish"],
		mutationFn: submitForPublish,
		retry: 0,
		onSuccess() {
			queryClient.invalidateQueries({ queryKey: ["getAdditionalInfo"] });
			toast.success("Methodology submitted for publishing successfully");
			router.push(`/methodologies/my-methodologies`);
		},
		onError: (err: APIResponse) => {
			toastOnError(err, "Failed to submit methodology for publishing");
		},
	});
}
